export default "__VITE_ASSET__wsbHwHC___"